/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_Param,
  ListCommandResult_Param
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TParamType,
  TNonEmptyArray
} from "@graphql/helpers/utils.graphql";

type TParamByIdFunctions = {
  getByID: CommandResult_Param;
};
export type TParamByIdQueries = {
  param: TParamByIdFunctions;
};

export const paramById = (fields: TNonEmptyArray<TParamType>) => gql`
  query paramById($id: Guid!) {
    param {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Param")}
`;

type TParamAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_Param;
};
export type TParamAllWithPaginationQueries = {
  param: TParamAllWithPaginationFunctions;
};
export const paramAllWithPagination = (
  fields: TNonEmptyArray<TParamType>
) => gql`
  query paramAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    param {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Param")}
`;

type TParamGetLoginColorFunctions = {
  getLoginColor: CommandResult_Param;
};
export type TParamGetLoginColorQueries = {
  param: TParamGetLoginColorFunctions;
};

export const paramGetLoginColor = (fields: TNonEmptyArray<TParamType>) => gql`
  query paramGetLoginColor {
    param {
      getLoginColor {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Param")}
`;
